export const cilInputHdmi = ["24 24","<path d='M18.75 5.625v-4.875h-13.5v4.875h-1.5v6.164l3.375 7.364v4.098h9.75v-4.098l3.375-7.364v-6.164zM6.75 2.25h10.5v3.375h-1.5v-1.875h-1.5v1.875h-1.5v-1.875h-1.5v1.875h-1.5v-1.875h-1.5v1.875h-1.5zM18.75 11.461l-3.375 7.364v2.925h-6.75v-2.925l-3.375-7.364v-4.336h13.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-input-hdmi.js
// module id = null
// module chunks = 